// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Series_bottomLine__2Dn_j","Series":"Series_Series__1lBYY","title":"Series_title__gquBb","articles":"Series_articles__2deJ5"};